import { TabulatorFull as Tabulator } from "tabulator-tables";
import * as XLSX from "xlsx";

window.XLSX = XLSX;

export const initializeDataTable = (element, options, store) => {
    const { columns, buildApiUrl, ...tableOptions } = options;

    const token =
        store?.state?.access_token || localStorage.getItem("access_token");

    return new Tabulator(element, {
        layout: "fitColumns",

        pagination: true,
        paginationMode: "remote",
        paginationSize: tableOptions.paginationSize || 100,
        paginationSizeSelector: tableOptions.paginationSizeSelector || [
            100, 200, 500, 1000,
        ],

        dataLoader: true,

        ajaxURL: buildApiUrl(),

        ajaxURLGenerator: function (url, config, params) {
            const baseUrl = buildApiUrl();
            const separator = baseUrl.includes("?") ? "&" : "?";
            const query = new URLSearchParams(params).toString();

            return query ? `${baseUrl}${separator}${query}` : baseUrl;
        },

        ajaxConfig: {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
            },
        },

        sortMode: "remote",
        filterMode: "remote",

        columns,

        ...tableOptions,

        ajaxResponse: function (url, params, response) {
            if (response && Array.isArray(response.data)) {
                return {
                    data: response.data,
                    last_page: response.last_page || 1,
                    total: response.total || response.data.length,
                };
            }

            if (response?.data && Array.isArray(response.data.data)) {
                return {
                    data: response.data.data,
                    last_page: response.data.last_page || 1,
                    total: response.data.total || response.data.data.length,
                };
            }

            if (Array.isArray(response)) {
                return {
                    data: response,
                    last_page: 1,
                    total: response.length,
                };
            }

            return {
                data: [],
                last_page: 1,
                total: 0,
            };
        },
    });
};
